module.exports = "query isProductIdAvailable($id:String!){isProductIdAvailable(id:$id)}"